
import AppConfig from '@/AppConfig';
import Icon from '@/components/Icons/Icon.vue';
import store from '@/store';
import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { GooglePlacesSuggestions } from './GooglePlacesAutocomplete.vue';

@Component({
  components: {
    Icon,
    ValidationProvider,
  },
})
export default class GooglePlacesCombobox extends Vue {
  googlePlacesSuggestions: GooglePlacesSuggestions[] = [];
  googlePlacesLoading = false;
  googlePlacesTimout: any = '';
  sessionToken: string = uuid();
  selectedAddress: string = store.state.auth.team.line1;

  consumeGooglePlacesApi(type: string, queryOrPlaceId: string): void {
    axios
      .get(
        AppConfig.getAPIBaseUrl().concat(
          '/system/address/' + type + '/' + queryOrPlaceId + '/' + this.$i18n.locale + '/' + this.sessionToken
        )
      )
      .then((response) => {
        if (type === 'autocomplete') {
          this.googlePlacesSuggestions = response.data.predictions;
        } else {
          this.sessionToken = uuid();
          this.$emit('selectedAddressFromDropdown', response.data);

          // Remove City, Country from selection
          if (response.data.street && response.data.house) {
            this.selectedAddress = `${response.data.street} ${response.data.house}`;
          } else if (response.data.street && !response.data.house) {
            this.selectedAddress = response.data.street;
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
  // Watcher to detect if an address was selected from dropdown
  @Watch('selectedAddress', { deep: true })
  onGooglePlacesSelect(selection: GooglePlacesSuggestions): void {
    if (selection?.place_id) {
      this.consumeGooglePlacesApi('details', selection.place_id);
    } else {
      // if nothing is selected that means it is a manual entry and keep the address user wrote
      this.$emit('manualEntry', selection);
    }
  }
  // Detects address via user input
  detectAddress(userInput: string): void {
    this.googlePlacesLoading = true;

    // Make sure to not send too many requests
    clearTimeout(this.googlePlacesTimout);

    if (userInput?.length > 3) {
      this.googlePlacesTimout = setTimeout(() => {
        this.consumeGooglePlacesApi('autocomplete', userInput);
        this.googlePlacesLoading = false;
      }, 500);
    }
  }
}
